export const manifest = {
  screens: {
    scr_wlg05u: { name: "Home", route: "/", position: {"x":160,"y":220} },
    scr_oid81k: { name: "New Patient", route: "/new-patients", position: {"x":160,"y":2200} },
    scr_7vewqk: { name: "3-Years-Financings", route: "/financing", position: {"x":8560,"y":220} },
    scr_1yswfs: { name: "About", route: "/about", position: {"x":1560,"y":220} },
    scr_wdmdq3: { name: "Services", route: "/services", position: {"x":2960,"y":220} },
    scr_vo823c: { name: "Meet the Doctors", route: "/doctors", position: {"x":4360,"y":220} },
    scr_c6pjmi: { name: "Patient Reviews", route: "/#patient-reviews", position: {"x":5760,"y":220} },
    scr_t6lwp6: { name: "Contact & Hours", route: "/contact", position: {"x":7160,"y":220} },
    scr_bkng01: { name: "Online Booking", route: "/book", position: {"x":9960,"y":220} },
    scr_blog01: { name: "Blog", route: "/blog", position: {"x":11360,"y":220} },
  },
  sections: {
    sec_68wv6k: { name: "Medical Practice Website", x: 0, y: 0, width: 9920, height: 1180 },
    sec_uoyj98: { name: "New Patient Registration", x: 0, y: 1980, width: 1520, height: 1180 },
  },
  layers: [
    { kind: "section", id: "sec_68wv6k", children: [
      { kind: "screen", id: "scr_wlg05u" },
      { kind: "screen", id: "scr_1yswfs" },
      { kind: "screen", id: "scr_wdmdq3" },
      { kind: "screen", id: "scr_vo823c" },
      { kind: "screen", id: "scr_c6pjmi" },
      { kind: "screen", id: "scr_t6lwp6" },
      { kind: "screen", id: "scr_7vewqk" },
    ] },
    { kind: "section", id: "sec_uoyj98", children: [
      { kind: "screen", id: "scr_oid81k" },
    ] },
  ],
}
